import React, { FunctionComponent } from 'react';
import { FormattedMessage } from 'react-intl';
import { always, is } from 'ramda';
import { Form } from 'react-bootstrap';
import { IBindingCallback1 } from '../../common/models/callback';
import styles from './styles.module.scss';

interface IEmailTextAreaProps {
  variant?: 'default' | 'withSubject';
  subject?: string;
  customEmailHeader?: string | JSX.Element | (JSX.Element | string)[];
  customEmailFooter?: string | JSX.Element;
  message: string;
  disabled?: boolean;
  subjectDisabled?: boolean;
  onChange: IBindingCallback1<string>;
  onSubjectChange?: IBindingCallback1<string>;
}

const EmailTextArea: FunctionComponent<IEmailTextAreaProps> = ({
  customEmailHeader,
  customEmailFooter,
  message,
  subject,
  variant = 'default',
  disabled = false,
  subjectDisabled = false,
  onChange,
  onSubjectChange
}) => {
  const headerContent = is(Array, customEmailHeader)
    ? (customEmailHeader as (JSX.Element | string)[]).map((val, index) => (
      <div key={String(index)} className={styles.highlight}>{val}</div>
    ))
    : (
      <div className={styles.highlight}>
        {customEmailHeader || <FormattedMessage id="preview.emailHeader" defaultMessage="<first name>" />}
      </div>
    );

  return (
    <div className={styles.emailPreview}>
      {
      variant === 'withSubject'
        ? (
          <div className="d-flex align-items-center">
            <FormattedMessage id="preview.subject" defaultMessage="Subject" />
            <Form.Control
              value={subject}
              bsPrefix={`${styles.emailTextarea} ${styles.subjectForm} ml-3 ${disabled || subjectDisabled
                ? styles.disabled : ''}`}
              onChange={({ currentTarget }) => (onSubjectChange
                ? onSubjectChange(currentTarget.value) : always(undefined))}
            />
          </div>
        )
        : null
      }
      <header className={`${styles.emailPreviewItem} ${styles.emailHeader}`}>
        {headerContent}
      </header>
      <Form.Control
        bsPrefix={`${styles.emailPreviewItem} ${styles.emailTextarea} ${disabled ? styles.disabled : ''}`}
        as="textarea"
        value={message}
        onChange={({ currentTarget }) => onChange(currentTarget.value)}
      />
      <footer className={styles.emailPreviewItem}>
        {customEmailFooter
          ? <div className={styles.highlight}>{customEmailFooter}</div>
          : (
            <>
              <span>
                <FormattedMessage id="previewText.surveyLink" defaultMessage="Please complete the survey here: " />
              </span>
              <div className={styles.highlight}>
                <FormattedMessage id="previewText.emailFooter" defaultMessage="<Survey Link>" />
              </div>
            </>
          )}
      </footer>
    </div>
  );
};
export default EmailTextArea;
